import * as React from "react";

import BaseProductCategoryListLayout from "./BaseProductCategoryListLayout";
import ProductCategoryEditPopup from "../containers/products/ProductCategoryEditPopup";

export default function ({ categoryId }) {
  return BaseProductCategoryListLayout(<ProductCategoryEditPopup categoryId={categoryId} />);
}
